'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
var breakpoints = require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
var table = require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var caption = require('../standard-table/caption.js');
var standardTbody = require('../standard-table/standard-tbody.js');
var table$1 = require('../standard-table/table.js');
var td = require('../standard-table/td.js');
var tfoot = require('../standard-table/tfoot.js');
var th = require('../standard-table/th.js');
var thead = require('../standard-table/thead.js');
var tr = require('../standard-table/tr.js');
var dndHandleTd = require('./dnd-handle-td.js');
var dndTableDragContext = require('./dnd-table-drag-context.js');
var dndTr = require('./dnd-tr.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/** The "rowKey" used for the handle column */ const DND_HANDLE_ROW_KEY = 'handle';
const UnstyledDndTable = (props)=>{
    const { breakpoints: breakpoints$1 =[
        breakpoints.Breakpoints.Sm
    ] , caption: caption$1 , captionProps , colGroup , columns , empty , emptyContent , emptyTrProps , error , errorContent , errorTrProps , footer , footerContent , hover =true , id , loaderLabel ='' , loaderTrProps , loading , look =table.TableLooks.Default , maxHeight , rows , scrollX =true , scrollY , showCaption , tableProps , tbodyProps , tdProps , tfootProps , thProps , theadProps , trProps  } = props;
    const format = props.format || id;
    /*
   * We need to have unique keys of each row so that when they are shifted around React re-renders them properly,
   * otherwise React only re-renders the contents instead of the entire <tr> DOM element because it thinks only the
   * values in that array element's object have changed rather than the element's actual position.
   *
   * As rows don't have unique identifiers, a WeakMap is used to store a random identifier with the row's object
   * reference as the key. A random identifer was chosen over using the start index of the row because if the rows prop
   * changes in size many times then index collisions can occur.
   */ const rowToIdMapRef = React.useRef(new WeakMap());
    /**
   * As WeakMaps are not enumerable, we need a Map of row IDs to StandardTableRow.
   */ const rowIdToRowMapRef = React.useRef(new Map());
    const [hoveredRowIndex, setHoveredRowIndex] = React.useState();
    const [dragData, setDragData] = React.useState();
    const isDragging = !!dragData;
    const { table: table$2  } = styled.useTheme();
    const trHoverBackgroundColor = table$2[look].trHoverBackgroundColor;
    const moveRow = (dragRowId, hoverRowId)=>{
        const rowIdToRowMap = rowIdToRowMapRef.current;
        const dragRow = rowIdToRowMap.get(dragRowId);
        const hoverRow = rowIdToRowMap.get(hoverRowId);
        if (!dragRow || !hoverRow) {
            // Failed to look up at least one row with its ID, this shouldn't happen unless the ID is invalid.
            console.warn('DndTable: moveRow called but a row is undefined after looking up by rowId');
            return;
        }
        const dragRowIndex = rows.indexOf(dragRow);
        const hoverRowIndex = rows.indexOf(hoverRow);
        props.moveRow(dragRowIndex, hoverRowIndex);
        setHoveredRowIndex(hoverRowIndex);
    };
    const onRowDropped = (event, format, dragData)=>{
        const rowIdToRowMap = rowIdToRowMapRef.current;
        const droppedRow = rowIdToRowMap.get(dragData.rowId);
        if (!droppedRow) {
            // Failed to look up the dropped row with its ID, this shouldn't happen unless the ID is invalid.
            console.warn('DndTable: onRowDropped called but the dropped row is undefined after looking up by rowId');
            return;
        }
        props.onRowDropped(event, format, droppedRow, rows.indexOf(droppedRow));
    };
    const generateRowId = (row)=>{
        const newId = Math.floor(Math.random() * 10 ** 16);
        rowToIdMapRef.current.set(row, newId);
        rowIdToRowMapRef.current.set(newId, row);
        return newId;
    };
    const columnsLength = columns.length;
    const rowsLength = rows.length;
    const isEmpty = empty ?? rowsLength === 0;
    return /*#__PURE__*/ React__default.default.createElement(dndTableDragContext.DndTableDragContext.Provider, {
        value: {
            data: dragData
        }
    }, /*#__PURE__*/ React__default.default.createElement(table$1.Table, _extends({}, tableProps, {
        breakpoints: breakpoints$1,
        empty: isEmpty,
        error: error,
        footer: footer,
        hover: false,
        id: id,
        loading: loading,
        look: look,
        maxHeight: maxHeight,
        scrollX: scrollX,
        scrollY: scrollY
    }), /*#__PURE__*/ React__default.default.createElement(caption.Caption, _extends({}, captionProps, {
        breakpoints: breakpoints$1,
        showCaption: showCaption
    }), caption$1), colGroup && colGroup, /*#__PURE__*/ React__default.default.createElement(thead.THead, _extends({}, theadProps, {
        breakpoints: breakpoints$1
    }), /*#__PURE__*/ React__default.default.createElement(tr.Tr, _extends({}, trProps, {
        breakpoints: breakpoints$1,
        look: look
    }), columns.map((column, columnIndex)=>/*#__PURE__*/ React__default.default.createElement(th.Th, _extends({}, thProps, {
            breakpoints: breakpoints$1,
            key: `${id}-th-${columnIndex}`,
            centered: column.centered,
            scope: "col",
            style: {
                maxWidth: column.maxWidth,
                minWidth: column.minWidth,
                width: column.width
            },
            title: column.headingTitle
        }), column.children)))), /*#__PURE__*/ React__default.default.createElement(standardTbody.StandardTBody, _extends({}, tbodyProps, {
        breakpoints: breakpoints$1,
        columnsLength: columnsLength,
        empty: isEmpty,
        emptyContent: emptyContent,
        emptyTrProps: emptyTrProps,
        error: error,
        errorContent: errorContent,
        errorTrProps: errorTrProps,
        loaderLabel: loaderLabel,
        loaderTrProps: loaderTrProps,
        loading: loading,
        style: {
            cursor: isDragging ? 'grabbing' : 'grab'
        }
    }), rows.map((row, rowIndex)=>{
        const rowId = rowToIdMapRef.current.get(row) || generateRowId(row);
        const isRowHovered = !isDragging && hoveredRowIndex === rowIndex;
        return /*#__PURE__*/ React__default.default.createElement(dndTr.DndTr, _extends({}, trProps, {
            breakpoints: breakpoints$1,
            format: format,
            key: `${id}-tr-${rowToIdMapRef.current.get(row)}`,
            look: look,
            moveRow: moveRow,
            onDropped: onRowDropped,
            onMouseEnter: ()=>setHoveredRowIndex(rowIndex),
            onMouseLeave: ()=>setHoveredRowIndex(undefined),
            rowId: rowId,
            setDragData: setDragData,
            style: {
                backgroundColor: hover && isRowHovered && trHoverBackgroundColor || 'transparent'
            }
        }), columns.map((column, columnIndex)=>{
            const TdComponent = column.rowKey === DND_HANDLE_ROW_KEY ? dndHandleTd.DndHandleTd : td.Td;
            const handleProps = column.rowKey === DND_HANDLE_ROW_KEY ? {
                showHandle: isRowHovered
            } : {};
            return /*#__PURE__*/ React__default.default.createElement(TdComponent, _extends({}, tdProps, handleProps, {
                className: classnames__default.default({
                    [`${column.tdClassName}`]: !!column.tdClassName,
                    [`${tdProps?.className}`]: !!tdProps?.className
                }),
                key: `${id}-td-${columnIndex}`,
                breakpoints: breakpoints$1,
                centered: column.centered,
                ellipsis: column.ellipsis,
                heading: column.heading,
                style: {
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth,
                    width: column.width
                },
                title: column.cellTitle
            }), row[column.rowKey]);
        }));
    })), footer && footerContent && /*#__PURE__*/ React__default.default.createElement(tfoot.TFoot, _extends({}, tfootProps, {
        breakpoints: breakpoints$1
    }), /*#__PURE__*/ React__default.default.createElement(tr.Tr, _extends({}, trProps, {
        breakpoints: breakpoints$1,
        look: look
    }), /*#__PURE__*/ React__default.default.createElement(td.Td, _extends({}, tdProps, {
        breakpoints: breakpoints$1,
        colSpan: columnsLength
    }), footerContent)))));
};
/**
 * A table component that supports drag and drop rearranging of rows.
 *
 * Required fields include `id`, `caption`, `columns`, `rows`, `moveRow`, `onRowDropped`.
 *
 * `id` should be a unique identifer for the table. Optionally, a `format` prop can be passed that will be used
 * for the DataTransfer format name during drag and drop. By default it is set to the value of `id`.
 *
 * `caption` is the title displayed above the table.
 *
 * `columns` is an array of `StandardTableColumn` describing the columns in the table. Optionally, a handle column can
 * be added with this definition:
 * ```
 * {
 *   children: '',
 *   heading: '',
 *   rowKey: DND_HANDLE_ROW_KEY,
 *   tdClassName: 'handle'
 * }
 * ```
 *
 * `rows` is an array of `StandardTableRow` describing the rows in the table. If elected to add a handle column, the
 * contents of the handle column can optionally be specified with `[DND_HANDLE_ROW_KEY]: children` key/value pair.
 *
 * `moveRow` is called whenever the row being dragged is moved over another row in the table. It is expected this
 * implementation updates the rows array passed to the component. For example, with `rows` in a state variable in the
 * consumg component the array can be updated with the following implementation:
 * ```
 * const moveRow = (dragRowIndex: number, hoverRowIndex: number): void => {
 *   setRows((prevRows) => {
 *     const newRows = [...prevRows];
 *     const theRow = newRows.splice(dragRowIndex, 1)[0];
 *     newRows.splice(hoverRowIndex, 0, theRow);
 *     return [...newRows];
 *   });
 * };
 * ```
 *
 * `onRowDropped` is called when either the `drop` or `dragend` event is triggered, whichever comes first. This gives
 * notification that the dragging operation is concluded. Post-dragging operations shuold be done here.
 * ```
 * const onRowDropped = (
 *   event: DragEvent,
 *   format: DragAndDropFormats | string,
 *   row: StandardTableRow,
 *   index: number
 * ): void => {
 *   // dragging complete, persist changes, etc.
 * }
 * ```
 *
 * @param props DndTableProps
 * @returns FunctionComponent<DndTableProps>
 */ const DndTable = (props)=>{
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(UnstyledDndTable, _extends({}, props)));
};

exports.DND_HANDLE_ROW_KEY = DND_HANDLE_ROW_KEY;
exports.DndTable = DndTable;
//# sourceMappingURL=dnd-table.js.map
